import { Seo } from '../components/Seo';

export function QReservePage() {
  return (
    <section className="qr-mobile q-landing-shell">
      <Seo title="타로맨스 | Q Reserve" description="QR 전용 예약 진입 페이지" />
      <article className="card q-landing-card">
        <p className="eyebrow">Q Reserve</p>
        <h1>예약 문의를 빠르게 연결합니다.</h1>
        <p>텍스트를 줄이고 예약 행동만 남긴 QR/NFC 전용 랜딩입니다.</p>
        <a className="btn active" href="tel:050713619410">전화로 예약 문의</a>
      </article>
    </section>
  );
}
